import './Stats.scss';
import './StatsDashboard.scss';
import Component from './Stats.js';
export default Component;
